"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeCardBody = void 0;
const ui_1 = require("@app/component/ui");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const use_local_storage_state_1 = require("@app/util/hooks/use-local-storage-state");
const react_1 = __importDefault(require("react"));
const employee_card_context_1 = require("../util/employee-card-context");
const employee_info_header_1 = require("./sections/employee-info-header");
const EmployeeCardBodyStats = ({ selectedTab, loading, dataSize }) => {
    const { value: useEmployeeCardV2DevData } = (0, use_local_storage_state_1.useLocalStorageState)('ds-dev-employee-card-v2-dev-data', (v) => ((0, util_1.isNotNull)(v) ? JSON.parse(v) : null), window.localStorage.getItem('ds-dev-employee-card-v2-dev-data') === 'true');
    if (!useEmployeeCardV2DevData)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_MEDIUM }, "Development data"),
        react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_SMALL },
            "Page: ",
            selectedTab),
        react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_SMALL },
            "Loading: ",
            loading.length > 0 ? 'true - ' : 'false',
            loading.join(',')),
        react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_SMALL },
            "Data: ",
            util_1.numberUtil.round2decimals(dataSize / 1000),
            " kB - ",
            dataSize,
            " bytes")));
};
const EmployeeCardBody = () => {
    const { selectedTab, employeeCardTabs, employee } = (0, employee_card_context_1.useEmployeeCard)();
    const loading = (0, store_1.useRootSelector)((state) => state.loading);
    const dataSize = (0, store_1.useRootSelector)((state) => JSON.stringify(state.userDetails).length);
    // TODO: Loading\
    if ((0, util_1.isUndefined)(employee.user))
        return react_1.default.createElement(ui_1.Loader, null);
    return (react_1.default.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
        } },
        react_1.default.createElement(employee_info_header_1.EmployeeInfoHeader, null),
        react_1.default.createElement(EmployeeCardBodyStats, { selectedTab: selectedTab, loading: loading, dataSize: dataSize }),
        react_1.default.createElement("div", { className: 'ds-ec-body' }, employeeCardTabs.find((tab) => tab.id === selectedTab)?.component)));
};
exports.EmployeeCardBody = EmployeeCardBody;
